// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './retailCollections.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import {
  setDateFilter,
  getCollectionsSummary,
  filterTableData,
  makeEditPaymentCall,
  makeTdsApplicableCall,
  getBankDetails,
  getRivigoBankDetails,
  getAllowedPaymentTypes,
  makeGetChequeNumberCall,
  getShortPaymentReasons,
  getUtrDetails,
  initiateOnlinePayment,
  checkOnlinePaymentStatus,
  cancelOnlinePayment,
  resendPaymentLink,
  setLocationFilterValue
} from './retailCollectionsRedux/retailCollectionsActionCreator';
import {
  shouldTableDataBeFetchedForNewDateRange,
  shouldTableDataBeFetchedForLocationChange,
  getColumnSum,
  getSelectOptionList,
  isZoomFinanceManager
} from '../../../services/helpers';
import SummaryCard from '../../commons/summaryCard/summaryCard';
import SearchBox from '../../commons/searchBox/searchBox';
import DateRangeFilter from '../../commons/dateFilter/dateFilter';
import Select from '../../commons/formElements/select/select';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import Loader from '../../commons/loader/loader';
import AlertsBar from '../../commons/alertsBar/alertsBar';
import EditPaymentDetails from '../../commons/editPaymentDetailsModal/editPaymentDetailsModal';
import { retailCollectionsSummaryTableConfig } from './retailCollectionsHelper';
import { isEditAllowedForRetailCollections } from '../../../services/helpers';
import UploadTanModal from '../rpCollections/component/UploadTanModal';

type Props = {
  retailCollectionsState: Object,
  userProfile: Object,
  setPageName: Function,
  setDateFilter: Function,
  getCollectionsSummary: Function,
  filterTableData: Function,
  makeEditPaymentCall: Function,
  makeTdsApplicableCall: Function,
  getBankDetails: Function,
  getRivigoBankDetails: Function,
  getAllowedPaymentTypes: Function,
  makeGetChequeNumberCall: Function,
  getShortPaymentReasons: Function,
  initiateOnlinePayment: Function,
  checkOnlinePaymentStatus: Function,
  cancelOnlinePayment: Function,
  resendPaymentLink: Function
};

type State = {
  resetSearchText: boolean,
  searchString: string,
  handoverStatusOptions: Array<any>,
  handoverStatusSelectedOption: string,
  paymentModeOptions: Array<any>,
  paymentModeSelectedOption: string,
  collectedByOptions: Array<any>,
  collectedBySelectedOption: string,
  showEditPaymentDetailsModal: boolean,
  tableData: Array<any>,
  editPaymenPrefillData: Object,
  uploadTanModal: boolean
};

const pageObj = {
  pageName: 'COLLECTIONS SUMMARY',
  betaPage: false
};

class RetailCollections extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.selectedComponentKey = 'RTL_COLLECTIONS_SUMMARY';
    this.alertMessage = 'Nothing to show at the moment';
    this.tableActionFunctions = {
      RTL_COLLECTIONS_SUMMARY: Object.assign(
        {},
        {
          editPaymentDetails: rowData => {
            // eslint-disable-next-line
            console.log('Add editPaymentDetails Modal here!, ', rowData);
            this.openEditPaymentDetailsModal(true, rowData);
          },
          isEditAllowedForRetailCollections: () => {
            return isEditAllowedForRetailCollections(props.userProfile);
          }
        }
      )
    };
    this.state = {
      resetSearchText: false,
      searchString: null,
      uploadTanModal: false,
      handoverStatusOptions: [
        { key: 'Completed', val: 'Completed' },
        { key: 'Pending', val: 'Pending' },
        { key: 'Recovery Pending', val: 'Recovery Pending' },
        { key: 'Recovery Completed', val: 'Recovery Completed' },
        { key: 'Write-off Pending', val: 'Write-off Pending' },
        { key: 'Write-off Completed', val: 'Write-off Completed' }
      ],
      handoverStatusSelectedOption: null,
      paymentModeOptions: [
        { key: 'Cash', val: 'Cash' },
        { key: 'Cheque', val: 'Cheque' },
        { key: 'Online', val: 'Online' },
        { key: 'QR Code', val: 'QR Code' },
        { key: 'Write-Off', val: 'Write-Off' },
        { key: 'Bank Transfer', val: 'Bank Transfer' }
      ],
      locationList: [],
      paymentModeSelectedOption: null,
      collectedByOptions: [],
      collectedBySelectedOption: null,
      showEditPaymentDetailsModal: false,
      editPaymenPrefillData: {}
    };

    this.editPaymentDetailsModalTheme = {
      // name: "themeBlack",
      titleCenter: true
    };

    this.refreshTableData = this.refreshTableData.bind(this);
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentWillReceiveProps(nextProps) {
    if (
      shouldTableDataBeFetchedForNewDateRange(
        nextProps.retailCollectionsState.filterValues,
        this.props.retailCollectionsState.filterValues
      ) ||
      shouldTableDataBeFetchedForLocationChange(
        nextProps.retailCollectionsState.filterValues,
        this.props.retailCollectionsState.filterValues
      )
    ) {
      this.props.getCollectionsSummary(
        nextProps.retailCollectionsState,
        nextProps.userProfile
      );
    }

    if (nextProps.retailCollectionsState.tableData) {
      this.state.collectedByOptions = getSelectOptionList(
        nextProps.retailCollectionsState.tableData,
        'collectUserName'
      );
    }
  }

  componentDidMount() {
    let locationList = sessionStorage.getItem('locationList');
    locationList = JSON.parse(locationList);
    locationList = locationList || [];
    locationList = locationList.map(ele => {
      return {
        key: ele.code,
        val: ele.id
      };
    });
    this.setState({
      locationList: locationList
    });
  }

  openUploadTanModal = () => {
    this.setState({ uploadTanModal: true });
  };

  closeUploadTanModal = () => {
    this.setState({ uploadTanModal: false });
  };

  onSearchValueChange(val: string) {
    // eslint-disable-next-line
    console.log('on search', val);
    this.setState({ searchString: val });
    this.props.filterTableData({
      searchString: val,
      handoverStatusSelectedOption: this.state.handoverStatusSelectedOption,
      paymentModeSelectedOption: this.state.paymentModeSelectedOption,
      collectedBySelectedOption: this.state.collectedBySelectedOption
    });
  }

  onHandoverStatusChange(val: string) {
    // eslint-disable-next-line
    console.log('on onHandoverStatusChange', val);
    this.setState({ handoverStatusSelectedOption: val });
    this.props.filterTableData({
      searchString: this.state.searchString,
      handoverStatusSelectedOption: val,
      paymentModeSelectedOption: this.state.paymentModeSelectedOption,
      collectedBySelectedOption: this.state.collectedBySelectedOption
    });
  }

  onPaymentModeChange(val: string) {
    // eslint-disable-next-line
    console.log('on onPaymentModeChange', val);
    this.setState({ paymentModeSelectedOption: val });
    this.props.filterTableData({
      searchString: this.state.searchString,
      handoverStatusSelectedOption: this.state.handoverStatusSelectedOption,
      paymentModeSelectedOption: val,
      collectedBySelectedOption: this.state.collectedBySelectedOption
    });
  }
  onCollectedByChange(val: string) {
    // eslint-disable-next-line
    console.log('on onCollectedByChange', val);
    this.setState({ collectedBySelectedOption: val });
    this.props.filterTableData({
      searchString: this.state.searchString,
      handoverStatusSelectedOption: this.state.handoverStatusSelectedOption,
      paymentModeSelectedOption: this.state.paymentModeSelectedOption,
      collectedBySelectedOption: val
    });
  }

  openEditPaymentDetailsModal(openCloseFlag, prefillValue, refreshFlag) {
    // eslint-disable-next-line
    console.log(' open close HandoverDetailsModal ');
    this.setState(
      {
        showEditPaymentDetailsModal: openCloseFlag,
        editPaymenPrefillData: prefillValue || {}
      },
      () => {
        if (refreshFlag) {
          this.refreshTableData();
        }
      }
    );
  }

  refreshTableData() {
    this.props.getCollectionsSummary(
      this.props.retailCollectionsState,
      this.props.userProfile
    );
  }

  summaryFilterFunction(row: Object, filterObj: Object) {
    const filterArrayLength = filterObj.filterColummnKeys.length;

    for (let i = 0; i < filterArrayLength; i += 1) {
      if (filterObj.filterColummnKeys[i] === 'handoverStatus') {
        if (
          filterObj.filterValues[i] === 'Completed' &&
          row.handoverTransactionId === null
        ) {
          return false;
        } else if (
          filterObj.filterValues[i] === 'Pending' &&
          row.handoverTransactionId !== null
        ) {
          return false;
        }
      } else if (
        row[filterObj.filterColummnKeys[i]].toLowerCase() !==
        filterObj.filterValues[i].toLowerCase()
      ) {
        return false;
      }
    }

    return true;
  }

  selectedComponentKey: string;
  tableActionFunctions: Object;
  editPaymentDetailsModalTheme: Object;
  render() {
    if (this.props.userProfile.authorities.indexOf('ROLE_ZOOM_BP') >= 0) {
      retailCollectionsSummaryTableConfig.columns[3].show = true;
    }
    const {
      isLoading,
      tableData,
      tableDataFiltered
    } = this.props.retailCollectionsState;
    const tableDataLength =
      tableDataFiltered !== null ? tableDataFiltered.length : 0;
    const topayTotalCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode'],
        filterValues: ['To Pay']
      },
      null
    );
    const paidTotalCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode'],
        filterValues: ['Paid']
      },
      null
    );
    const topayHandoverCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode', 'handoverStatus'],
        filterValues: ['To Pay', 'Completed']
      },
      this.summaryFilterFunction
    );
    const paidHandoverCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode', 'handoverStatus'],
        filterValues: ['Paid', 'Completed']
      },
      this.summaryFilterFunction
    );
    const topayPendingCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode', 'handoverStatus'],
        filterValues: ['To Pay', 'Pending']
      },
      this.summaryFilterFunction
    );
    const paidPendingCollection = getColumnSum(
      // tableData,
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['paymentMode', 'handoverStatus'],
        filterValues: ['Paid', 'Pending']
      },
      this.summaryFilterFunction
    );
    const handoverDonePerecentage =
      topayTotalCollection + paidTotalCollection > 0
        ? ((topayHandoverCollection + paidHandoverCollection) * 100) /
          (topayTotalCollection + paidTotalCollection)
        : 0;
    return (
      <div className={`${styles.retailCollectionsWrapper}`}>
        <div className={`${styles.filterPanelParent} l-row a-center`}>
          <div className={`${styles.filterPanelLeft} l-row flex-70`}>
            <div className={`${styles.filterLabel} l-row a-center`}>
              Filter By:
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <DateRangeFilter
                setDateFilter={this.props.setDateFilter}
                displayFormat="DD MMM YY"
                isOutsideRangeCheck={true}
              />
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <Select
                label="Handover status"
                optionsArrOfObj={this.state.handoverStatusOptions}
                onSelect={val => {
                  this.onHandoverStatusChange(val);
                }}
              />
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <Select
                label="Payment mode"
                optionsArrOfObj={this.state.paymentModeOptions}
                onSelect={val => {
                  this.onPaymentModeChange(val);
                }}
              />
            </div>
            {this.props.userProfile.authorities.indexOf('ROLE_ZOOM_BP') >= 0 ? (
              <div className={`${styles.filterComponentWrapper}`}>
                <Select
                  label="Collected by"
                  optionsArrOfObj={this.state.collectedByOptions}
                  onSelect={val => {
                    this.onCollectedByChange(val);
                  }}
                />
              </div>
            ) : null}
            <div className={`${styles.filterComponentWrapper}`}>
              <Select
                label="Location"
                enableSearch={true}
                optionsArrOfObj={this.state.locationList}
                onSelect={(val, obj) => {
                  this.props.setLocationFilterValue(obj.val);
                }}
              />
            </div>
            {this.props.userProfile &&
              isZoomFinanceManager(this.props.userProfile) && (
                <div className={`${styles.filterComponentWrapper}`}>
                  <button
                    type="button"
                    className={`${styles.uploadTanBtn}`}
                    onClick={this.openUploadTanModal}
                  >
                    Upload TAN
                  </button>
                </div>
              )}
          </div>
          <div className={`${styles.filterPanelRight} l-row flex-30 j-end`}>
            <div className={`${styles.filterComponentWrapper}`}>
              <SearchBox
                onSearchValueChange={val => this.onSearchValueChange(val)}
                resetSearchText={this.state.resetSearchText}
              />
            </div>
          </div>
        </div>

        <div className={`${styles.summaryCardParent} l-row`}>
          <SummaryCard
            totalAmount={paidTotalCollection + topayTotalCollection}
            totalAmountTag="Total Collection"
            subAmountLeft={paidTotalCollection}
            subAmountLeftTag="Paid"
            subAmountRight={topayTotalCollection}
            subAmountRightTag="To Pay"
            showPercentage={false}
          />
          <SummaryCard
            totalAmount={topayHandoverCollection + paidHandoverCollection}
            totalAmountTag="Handover"
            subAmountLeft={paidHandoverCollection}
            subAmountLeftTag="Paid"
            subAmountRight={topayHandoverCollection}
            subAmountRightTag="To Pay"
            showPercentage={true}
            percentage={handoverDonePerecentage}
          />
          <SummaryCard
            totalAmount={topayPendingCollection + paidPendingCollection}
            totalAmountTag="Pending"
            subAmountLeft={paidPendingCollection}
            subAmountLeftTag="Paid"
            subAmountRight={topayPendingCollection}
            subAmountRightTag="To Pay"
            showPercentage={false}
          />
        </div>
        <div className={`${styles.tableWrapper}`}>
          {isLoading ? <Loader /> : ''}
          {!isLoading && tableData && tableData.length ? (
            <ZoomTable
              configKey={this.selectedComponentKey}
              tableDataLength={tableDataLength}
              tableData={tableDataFiltered}
              actionFunctions={
                this.tableActionFunctions[this.selectedComponentKey]
              }
            />
          ) : (
            <AlertsBar message={this.alertMessage} loading={isLoading} />
          )}
        </div>

        <div className="edit-payment-details-modal-parent">
          <EditPaymentDetails
            showModal={this.state.showEditPaymentDetailsModal}
            closeModal={(val, refreshFlag) =>
              this.openEditPaymentDetailsModal(val, null, refreshFlag)
            }
            modalTheme={this.editPaymentDetailsModalTheme}
            modalTitle="Edit Payment Details"
            editPaymentDetailsSubmitData={
              this.props.retailCollectionsState.editPaymentModalData
            }
            tdaApplicableData={
              this.props.retailCollectionsState.tdsApplicableData
            }
            makeTdsApplicableCall={(phoneNumber, isDelivery) =>
              this.props.makeTdsApplicableCall(phoneNumber, isDelivery)
            }
            submitAction={(
              paymentData,
              transactionScreenshotFile,
              tanCertificateFile
            ) =>
              this.props.makeEditPaymentCall(
                paymentData,
                transactionScreenshotFile,
                tanCertificateFile
              )
            }
            getChequeNumberAction={(chequeImageFile, cb) =>
              this.props.makeGetChequeNumberCall(chequeImageFile, cb)
            }
            getUtrDetails={(utrNo, cb) => this.props.getUtrDetails(utrNo, cb)}
            editPaymenPrefillData={this.state.editPaymenPrefillData}
            getBankDetails={() => this.props.getBankDetails()}
            getRivigoBankDetails={() => this.props.getRivigoBankDetails()}
            getShortPaymentReasons={() => this.props.getShortPaymentReasons()}
            getAllowedPaymentTypes={(paymentMode, amount) =>
              this.props.getAllowedPaymentTypes(paymentMode, amount)
            }
            initiateOnlinePayment={this.props.initiateOnlinePayment}
            checkOnlinePaymentStatus={this.props.checkOnlinePaymentStatus}
            cancelOnlinePayment={this.props.cancelOnlinePayment}
            resendPaymentLink={this.props.resendPaymentLink}
            bankData={this.props.retailCollectionsState.bankDetailsData}
            rivigoBankData={
              this.props.retailCollectionsState.rivigoBankDetailsData
            }
            allowedPaymentTypes={
              this.props.retailCollectionsState.allowedPaymentTypes
            }
            shortPaymentReasons={
              this.props.retailCollectionsState.shortPaymentReasons
            }
          />
        </div>

        {this.state.uploadTanModal && (
          <UploadTanModal
            open={this.state.uploadTanModal}
            closeModal={this.closeUploadTanModal}
            initCall={this.refreshTableData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  retailCollectionsState: state.retailCollectionsState,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  setDateFilter: bindActionCreators(setDateFilter, dispatch),
  getCollectionsSummary: bindActionCreators(getCollectionsSummary, dispatch),
  filterTableData: bindActionCreators(filterTableData, dispatch),
  makeEditPaymentCall: bindActionCreators(makeEditPaymentCall, dispatch),
  makeTdsApplicableCall: bindActionCreators(makeTdsApplicableCall, dispatch),
  getBankDetails: bindActionCreators(getBankDetails, dispatch),
  getRivigoBankDetails: bindActionCreators(getRivigoBankDetails, dispatch),
  getShortPaymentReasons: bindActionCreators(getShortPaymentReasons, dispatch),
  getAllowedPaymentTypes: bindActionCreators(getAllowedPaymentTypes, dispatch),
  makeGetChequeNumberCall: bindActionCreators(
    makeGetChequeNumberCall,
    dispatch
  ),
  getUtrDetails: bindActionCreators(getUtrDetails, dispatch),
  initiateOnlinePayment: bindActionCreators(initiateOnlinePayment, dispatch),
  checkOnlinePaymentStatus: bindActionCreators(
    checkOnlinePaymentStatus,
    dispatch
  ),
  cancelOnlinePayment: bindActionCreators(cancelOnlinePayment, dispatch),
  resendPaymentLink: bindActionCreators(resendPaymentLink, dispatch),
  setLocationFilterValue: bindActionCreators(setLocationFilterValue, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailCollections);
